export default __webpack_public_path__ + "static/home_page_measurement-4ae765bb3745d800e58b42e71f4fb057.mp4";